module.exports = __webpack_public_path__ + "static/media/IMG_1736y.888958b2.jpg";